import React from 'react';
import PropTypes from 'prop-types';
import IconMagnifier from '../../assets/icon_magnifier.svg';

function SellerSearchInput({ value, onChange, onEnter }) {
  return (
    <div className="Seller-search-field" data-name="SellerSearchInput">
      <img src={IconMagnifier} alt="검색" className="Seller-search-icon" />
      <input
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.isComposing) return; // 한글 IME 입력 중 엔터 방지
          if (e.key === 'Enter' && onEnter) onEnter();
        }}
        placeholder="검색"
        aria-label="상품 검색"
        className="Seller-search-input"
      />
    </div>
  );
}

SellerSearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
};

export default SellerSearchInput;
